import { Ref } from "react";
import {
  CreatorFragmentCommonProps,
  CreatorFragmentHandle,
} from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/creator-fragments/CreatorFragment";
import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import { useTranslation } from "@coworker/locales";
import MfaqQuestionHeader from "@coworker/apprestructured/src/task-management/components/MfaqQuestionHeader/MfaqQuestionHeader";
import { getTypedValue } from "@coworker/apprestructured/src/shared/helpers/schemaValidator";
import LoadingCreatorFragment from "@coworker/apprestructured/src/task-management/components/LoadingCreatorFragment/LoadingCreatorFragment";

export type MfaqQuestionCreatorFragmentConfigProps = Record<string, never>;

type MfaqQuestionCreatorFragmentProps = {
  configProps: MfaqQuestionCreatorFragmentConfigProps;
  commonProps: CreatorFragmentCommonProps;
  ref?: Ref<CreatorFragmentHandle>;
};

function MfaqQuestionCreatorFragment({
  commonProps,
}: MfaqQuestionCreatorFragmentProps) {
  const { task } = commonProps;
  const questionText = getTypedValue<string>(
    getByPath(task, "details.question_text")
  );

  const { t } = useTranslation();

  if (isLoading(questionText)) {
    return <LoadingCreatorFragment />;
  }

  if (questionText.length === 0) {
    return null;
  }

  return (
    <MfaqQuestionHeader
      label={t("questionStringMFAQ")}
      questionText={questionText}
    />
  );
}

export default MfaqQuestionCreatorFragment;
